import ErrorMessage from '@/components/common/error-message/ErrorMessage';
import GoBack from '@/components/common/go-back/GoBack';
import AlertModal from '@/components/common/modals/alert-modal/AlertModal';
import NoData from '@/components/common/no-data/NoData';
import ServiceGroupForm from '@/components/forms/form-service-group/ServiceGroupForm';
import { Skeleton } from '@/components/ui/skeleton';
import useEditServiceGroup from '@/hooks/pages/useEditServiceGroup';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const EditServiceGroup = () => {
  const { t } = useTranslation();
  const [deleteModal, setDeleteModal] = useState(false);
  const {
    serviceDivision,
    isError,
    isLoading,
    service,
    isPending,
    defaultValues,
    deleteServiceDivision,
    isPendingDelete,
    onSubmit,
    id
  } = useEditServiceGroup();

  if (isLoading) {
    return (
      <>
        <GoBack />
        <Skeleton className="w-full h-[50vh]" />
      </>
    );
  }

  if (!serviceDivision || !service) {
    return (
      <>
        <GoBack />
        <NoData />
      </>
    );
  }

  if (isError) {
    return (
      <>
        <GoBack />
        <ErrorMessage />
      </>
    );
  }

  return (
    <>
      <GoBack />
      <div className="p-5 space-y-6 rounded-md bg-accent">
        <p className="font-bold text-md text-primary">
          {t('serviceDetail.updateServiceDivision')} - {service.name}
        </p>
        <ServiceGroupForm
          isPending={isPending}
          onSubmit={onSubmit}
          isPendingDelete={isPendingDelete}
          onDelete={() => setDeleteModal(true)}
          defaultValues={defaultValues}
        />
      </div>
      <AlertModal
        open={deleteModal}
        onOpenChange={setDeleteModal}
        title={t('modals.alert.title')}
        description={t('modals.serviceDivision.deleteDescription')}
        cancelText={t('common.cancel')}
        acceptText={t('form.delete')}
        onAccept={() => deleteServiceDivision(id ?? '')}
        buttonAcceptDestructive
      />
    </>
  );
};

export default EditServiceGroup;
